module.exports = __webpack_public_path__ + "img/1275967329.8deb8cec.jpg";